export default __webpack_public_path__ + "static/media/Cardinal_logo.b8999991.png";